module.exports = __webpack_public_path__ + "static/media/unhappy200h.453a5569.png";